import React from "react";

export default function NewsModal({ url }) {

  if (!url) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const normalized = dateString
      .replace(" ", "T")       
      .replace(" +", "+");    

    const date = new Date(normalized);

    if (isNaN(date.getTime())) return "";

    return (
      date.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }) +
      " • " +
      date.toLocaleTimeString("de-DE", {
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  };

  if (url.type === "html") {
    return (
      <div className="news-page">
        <h1 className="news-title">{url.title}</h1>

        <div className="news-date">
          {formatDate(url.publishedAt)}
        </div>

        <div
          className="news-content"
          dangerouslySetInnerHTML={{ __html: url.content }}
        />
      </div>
    );
  }

  return (
    <div>
      <iframe
        allowtransparency="true"
        style={{
          width: "100vw",
          height: "calc(100vh - 200px)", 
          border: 0,
        }}
        src={url.url}
        title="news"
      ></iframe>
    </div>
  );
}
